import React, { useState } from 'react';

import { nanoid } from '@reduxjs/toolkit';

import { bemCssModules } from '@utils';

import Spinner from '@components/Spinner';

import ArrowIcon from './arrow.svg';

import style from './Select.scss';

const cn = bemCssModules(style, 'Select');

export type TSelect<T> = {
  isSmall?: boolean;
  options: T[];
  label?: string;
  keyValue?: string;
  keyLabel?: string;
  placeholder?: string;
  error?: string;
  isLoading?: boolean;
  onChange(event: React.ChangeEvent<HTMLSelectElement>): void;
} & React.SelectHTMLAttributes<HTMLSelectElement>;

const Select: CustomFC<TSelect<any>> = ({
  isSmall,
  options,
  onChange,
  label,
  keyValue = 'value',
  keyLabel = 'label',
  placeholder = '',
  error,
  isLoading = false,
  disabled,
  ...rest
}) => {
  const [id] = useState(nanoid());

  return (
    <div className={cn({ sm: isSmall })}>
      {label && (
        <label className={cn('label')} htmlFor={id}>
          {label}
        </label>
      )}
      <div className={cn('select-block', { disabled })}>
        {!isLoading ? (
          <>
            <select
              className={cn('select')}
              id={id}
              onChange={onChange}
              disabled={disabled}
              {...rest}
            >
              {!!placeholder && <option>{placeholder}</option>}
              {options.map(option => (
                <option key={option[keyValue]} value={option[keyValue]}>
                  {option[keyLabel]}
                </option>
              ))}
            </select>
            <ArrowIcon className={cn('arrow')} />
          </>
        ) : (
          <Spinner size={32} />
        )}
      </div>
      {error && <div className={cn('error')}>{error}</div>}
    </div>
  );
};

export default Select;
